import { formatNumber } from './formatNumber';
import { formatNumberExplicitly } from '../helpers/formatNumberExplicitly';
import { makeSpacesNonBreakable } from '../helpers/makeSpacesNonBreakable';
import { replacePattern } from '../helpers/replacePattern';
export function getFormattedCurrency(value, culture) {
  if (!culture) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    var unknownCurrency = formatNumber(value, culture);
    return {
      formattedCurrency: unknownCurrency,
      currencies: [unknownCurrency]
    };
  }
  var CurrencyFormat = culture.CurrencyFormat,
    _culture$FinancialSet = culture.FinancialSet,
    CurrencySymbol = _culture$FinancialSet.CurrencySymbol,
    DoubleCurrency = _culture$FinancialSet.DoubleCurrency;
  var formattedCurrency = makeSpacesNonBreakable(replacePattern(value < 0 ? CurrencyFormat.NegativePattern : CurrencyFormat.PositivePattern, {
    n: formatNumberExplicitly(value, CurrencyFormat.Decimals, CurrencyFormat.DecimalSeparator, CurrencyFormat.GroupSizes, CurrencyFormat.GroupSeparator, {
      removeTrailingZeros: CurrencyFormat.RemoveTrailingZeros
      // we can't use the negative pattern here because currencies have different positive and negative formatting pattern than decimals
    }),

    $: CurrencySymbol
  }));
  if (!DoubleCurrency) {
    return {
      formattedCurrency: formattedCurrency,
      currencies: [formattedCurrency]
    };
  }
  var negativePattern = DoubleCurrency.NegativePattern ? DoubleCurrency.NegativePattern : CurrencyFormat.NegativePattern;
  var positivePattern = DoubleCurrency.PositivePattern ? DoubleCurrency.PositivePattern : CurrencyFormat.PositivePattern;
  var pattern = value < 0 ? negativePattern : positivePattern;
  var formattedDoubleCurrency = makeSpacesNonBreakable(replacePattern(pattern, {
    n: formatNumberExplicitly(value * DoubleCurrency.ExchangeRate, DoubleCurrency.Decimals, DoubleCurrency.DecimalSeparator ? DoubleCurrency.DecimalSeparator : CurrencyFormat.DecimalSeparator, CurrencyFormat.GroupSizes, DoubleCurrency.GroupSeparator ? DoubleCurrency.GroupSeparator : CurrencyFormat.GroupSeparator, {
      removeTrailingZeros: DoubleCurrency.RemoveTrailingZeros
      // we can't use the negative pattern here because currencies have different positive and negative formatting pattern than decimals
    }),

    $: DoubleCurrency.CurrencySymbol
  }));
  return {
    formattedCurrency: formattedCurrency,
    formattedDoubleCurrency: formattedDoubleCurrency,
    currencies: [formattedDoubleCurrency, formattedCurrency]
  };
}